import { NuqsAdapter } from '@vrplatform/query-params';
import * as Sentry from '@sentry/react';
import { useMemo } from 'react';
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';
import { Auth } from './Auth';

export function BrowserRouter() {
  const router = useMemo(() => {
    // Call this AFTER Sentry.init()
    const sentryCreateBrowserRouter =
      Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

    return sentryCreateBrowserRouter(
      createRoutesFromElements(
        <Route
          path="*"
          element={
            <NuqsAdapter>
              <Auth />
            </NuqsAdapter>
          }
        />
      )
    );
  }, []);

  return <RouterProvider router={router} />;
}
